import "./print.css";

const ChungNhanView = ({ data }) => {
  return <div style={{ WebkitTransform: "scale(0.8)", WebkitTransformOrigin: "0 0", backgroundColor:"white" }} dangerouslySetInnerHTML={{ __html: data }}></div>;
};
export default ChungNhanView;
